import clsx from 'clsx';
import HubertSwitch from 'components/HubertUI/HubertSwitch';
import HubertLabel from 'components/HubertUI/HubertLabel';
import { useQuestionEditorContext } from '../context/create-question.context';
import { useAppDispatch, useAppSelector } from 'rtk/query/hooks';
import { selectQuestionRandomizeOrder, selectQuestionMode } from 'rtk/questionEditorSelector';
import { updateRandomizeOrder } from 'rtk/Question.Editor.Slice';
import { ECreateQuestionMode } from '../context/create-question.context';
import UneditableInfoTooltip from '../UneditableInfoTooltip';
import { useTranslation } from 'react-i18next';

const RandomizeOrderSwitch = () => {
  const { t } = useTranslation('Questionsv2');
  const dispatch = useAppDispatch();
  const { questionId } = useQuestionEditorContext();
  const randomizeOrder = useAppSelector((state) => selectQuestionRandomizeOrder(state, questionId));
  const mode = useAppSelector((state) => selectQuestionMode(state, questionId));

  const disabled = mode === ECreateQuestionMode.InTemplateEdit;

  return (
    <div className={clsx('hubert-vertical-center flex flex-row justify-between px-4')}>
      <UneditableInfoTooltip disabled={disabled}>
        <HubertSwitch
          id="create-question-randomize-order"
          disabled={disabled}
          checked={randomizeOrder}
          onCheckedChange={(checked: boolean) => {
            dispatch(updateRandomizeOrder({ questionId, value: checked }));
          }}
        />
      </UneditableInfoTooltip>
      <HubertLabel htmlFor="create-question-randomize-order" className={clsx('whitespace-nowrap')}>
        {t('randomizeOrder.label')}
      </HubertLabel>
    </div>
  );
};

export default RandomizeOrderSwitch;
